<template>
  <main class="main-esports">
    <section class="esports02-main zh_CN" style="margin-top: 105px">
      <div class="contain">
        <div class="esports02-wrap">
          <div class="tab-main">
            <ul>
              <li :class="platform_name == 'ld' ? 'api-item-bg item-tf active' : 'api-item-bg item-tf'" id="e-70">
                <video autoplay="autoplay" loop="loop" muted="true" type="video/mp4" poster="/static/image/video_tf.jpg" src="/static/image/video_tf.mp4"></video>
                <div class="api-item-txt">
                  <div class="api-logo" style="background-image: url(/static/image/logo_tf.png)"></div>
                  <div class="api-name-txt" style="background-image: url(/static/image/logo_txt_tf.png)"></div>
                  <p class="api-description">
                    
                    <font style="vertical-align: inherit"><font style="vertical-align: inherit">{{$t('index.TFdz')}}</font></font>
                  </p>
                  <a href="javascript:" class="start-btn _vr_mt_check"  data-apitype="6" data-api="70" @click="$parent.openGamePage('ld', '2', '')"
                    ><span></span></a
                  >
                </div>
              </li>
              <li :class="platform_name == 'avia' ? 'api-item-bg item-tf active' : 'api-item-bg item-tf'" id="e-69">
                <video autoplay="autoplay" loop="loop" muted="true" type="video/mp4" poster="/static/image/video_fy.jpg" src="/static/image/video_fy.mp4"></video>
                <div class="api-item-txt">
                  <div class="api-logo" style="background-image: url(/static/image/logo_fy.png)"></div>
                  <div class="api-name-txt" style="background-image: url(/static/image/logo_txt_fy.png)"></div>
                  <p class="api-description">
                    <font style="vertical-align: inherit"><font style="vertical-align: inherit">{{$t('index.fydz')}}</font></font>
                  </p>
                       <a href="javascript:" class="start-btn _vr_mt_check" data-apitype="6" data-api="19" @click="$parent.openGamePage('avia', '2', '')"
                    ><span></span></a
                  >
                 
                </div>
              </li>
              <li :class="platform_name == 'obgdj' ? 'api-item-bg item-sb active' : 'api-item-bg item-sb'" id="e-20">
                <video autoplay="autoplay" loop="loop" muted="true" type="video/mp4" poster="/static/image/video_fy.jpg" src="/static/image/video_fy.mp4"></video>
                <div class="api-item-txt">
                     <div class="api-logo" style="background-image: url(/static/image/logo_ob.png)"></div>
                  <div class="api-name-txt" style="background-image: url(/static/image/logo_txt_ob.png)"></div>
                  <p class="api-description">
                    <font style="vertical-align: inherit"><font style="vertical-align: inherit">{{$t('index.obdz')}}</font></font>
                  </p>
                  <a href="javascript:" class="start-btn _vr_mt_check" data-apitype="6" data-api="19" @click="$parent.openGamePage('obgdj', '2', '')"
                    ><span></span></a
                  >
                </div>
              </li>
              <li :class="platform_name == 'ia' ? 'api-item-bg item-sb active' : 'api-item-bg item-sb'" id="e-19">
                <video autoplay="autoplay" loop="loop" muted="true" type="video/mp4" poster="/static/image/video_sb.jpg" src="/static/image/video_sb.mp4"></video>
                <div class="api-item-txt">
                  <div class="api-logo" style="background-image: url(/static/image/logo_ia.png)"></div>
                  <div class="api-name-txt" style="background-image: url(/static/image/logo_txt_ia.png)"></div>
                  <p class="api-description">
                    <font style="vertical-align: inherit"><font style="vertical-align: inherit">{{$t('index.aidz')}}</font></font>
                  </p>
                  <a href="javascript:" class="start-btn _vr_mt_check" data-apitype="6" data-api="19" @click="$parent.openGamePage('ia', '2', '')"
                    ><span><!-- 立即开始 --></span></a
                  >
                </div>
              </li>
            </ul>
          </div>
          <div class="tab-nav" data-count="3">
            <ul>
              <li :class="platform_name == item.platform_name ? 'api-item-nav active' : 'api-item-nav'" @click="changplatform_name(item.platform_name)" v-for="(item, index) in gameList" :key="index" v-if="item.app_state == 1">
                <a href="javascript:" class="api-tf api-sb" :style="`background-image: url(${imgList[item.platform_name]['img']})`" :title="item.name">
                  <span :style="`background-image: url(${imgList[item.platform_name]['hover']})`"></span>
                </a>
              </li>
            </ul>
            <ul v-if="false">
              <li class="api-item-nav" data-id="e-70">
                <a href="javascript:" class="api-tf" style="background-image: url(/static/image/tab_tf.png)" >
                  <span style="background-image: url(/static/image/tab_tf_hover.png)"></span>
                </a>
              </li>
              <li class="api-item-nav" data-id="e-69">
                <a href="javascript:" class="api-fy" style="background-image: url(/static/image/tab_fy.png)" >
                  <span style="background-image: url(/static/image/tab_fy_hover.png)"></span>
                </a>
              </li>
              <li class="api-item-nav" data-id="e-20">
                <a href="javascript:" class="api-sb" style="background-image: url(/static/image/tab_ob.png)" >
                  <span style="background-image: url(/static/image/tab_ob_hover.png)"></span>
                </a>
              </li>
              <li class="api-item-nav active" data-id="e-19">
                <a href="javascript:" class="api-sb" style="background-image: url(/static/image/tab_ia.png)" >
                  <span style="background-image: url(/static/image/tab_ia_hover.png)"></span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>
<script>
export default {
  name: 'gaming',
  data() {
    return {
      gameList: [],
      platform_name: '',
      imgList: {
        ia: { img: '/static/image/gaming/tab_ia.png', hover: '/static/image/tab_ia_hover.png', title: '/static/image/tab_ia_hover.png' },
        ld: { img: '/static/image/tab_tf.png', hover: '/static/image/tab_tf_hover.png', title: '/static/image/img_ld_title-.png' },
        avia: { img: '/static/image/tab_fy.png', hover: '/static/image/tab_fy_hover.png', title: '/static/image/img_avia_title.png' },
        obgdj: { img: '/static/image/gaming/tab_ob.png', hover: '/static/image/gaming/tab_ob_hover.png', title: '/static/image/logo_txt_ob.png' },
      },
    };
  },
  created() {
    let that = this;
    that.getGameList();
  },
  methods: {
    changplatform_name(val) {
      this.platform_name = val;
    },
    getGameList() {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun.get('/api/game/list', { category: 'gaming' }).then(res => {
        if (res.code == 200) {
          that.gameList = res.data;
          let arr = that.gameList;

          for (let i in arr) {
            if (arr[i]['app_state'] == 1) {
              that.platform_name = arr[i]['platform_name'];
              that.$parent.hideLoading();

              return;
            }
          }
          that.$parent.hideLoading();
        }
      });
    },
  },
  mounted() {
    let that = this;

    $(function () {
      function loadBgVideo(bgItem) {
        // 懒加载背景预览图和视频
        let bgPoster = bgItem.find('video').attr('data-poster');
        let bgVideo = bgItem.find('video').attr('data-src');
        bgPoster && bgItem.find('video').attr('poster', bgPoster).removeAttr('data-poster');
        bgVideo && bgItem.find('video').attr('src', bgVideo).removeAttr('data-src');
      }

      loadBgVideo($('.esports02-wrap .api-item-bg.active'));

      $('.esports02-wrap .tab-nav .api-item-nav').click(function () {
        $(this).addClass('active').siblings().removeClass('active');
        var _id = $(this).attr('data-id');
        let bgItem = $('.esports02-wrap #' + _id);
        bgItem.addClass('active').siblings().removeClass('active');

        loadBgVideo(bgItem);
      });
    });
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/translateelement.css';
/*========== 电竞竞猜 ==========*/
@keyframes videoFadeIn {
  0% {
    opacity: 0;
    margin-left: -20px;
  }
  100% {
    opacity: 1;
    margin-left: 0;
  }
}
@keyframes txtFadeIn {
  0% {
    opacity: 0;
    margin-top: -20px;
  }
  100% {
    opacity: 1;
    margin-top: 0;
  }
}
/*内容主体和背景视频 tab-main*/
.esports02-main {
  background: #000;
  overflow: hidden;
}
.esports02-main .contain {
  position: relative;
  width: 1200px;
  margin: auto;
  overflow: visible;
  transition: width 0.3s;
}
.esports02-main .esports02-wrap {
  position: relative;
  width: 100%;
  height: 785px;
}
.esports02-main .esports02-wrap .tab-main {
  position: relative;
  width: 100%;
  height: 785px;
}
.esports02-main .esports02-wrap .tab-main ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.esports02-main .esports02-wrap .tab-main ul .api-item-bg {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
.esports02-main .esports02-wrap .tab-main ul .api-item-bg.active {
  display: block;
}
.esports02-main .esports02-wrap .tab-main ul .api-item-bg video {
  position: absolute;
  left: 50%;
  top: 0;
  z-index: 10;
  transform: translateX(-50%);
  width: 1920px;
  height: 100%;
  pointer-events: none;
  animation: videoFadeIn 1.5s ease;
}
.esports02-main .esports02-wrap .tab-main ul .api-item-bg .api-item-txt {
  position: relative;
  z-index: 30;
  width: 500px;
  padding-top: 30px;
  text-align: center;
  animation: txtFadeIn 1s ease;
}
.esports02-main .esports02-wrap .tab-main ul .api-item-bg .api-item-txt .api-logo {
  height: 120px;
  background: no-repeat center / contain;
}
.esports02-main .esports02-wrap .tab-main ul .api-item-bg .api-item-txt .api-name-txt {
  height: 80px;
  margin-top: 10px;
  background: no-repeat center / contain;
}
.esports02-main .esports02-wrap .tab-main ul .api-item-bg .api-item-txt .api-description {
  min-height: 96px;
  line-height: 1.2;
  margin-top: 10px;
  font-size: 18px;
  color: #ffffff;
}
.esports02-main .esports02-wrap .tab-main ul .api-item-bg .api-item-txt .start-btn {
  display: block;
  width: 237px;
  height: 82px;
  margin: 20px auto 0;
  font-size: 0;
}
.esports02-main .esports02-wrap .tab-main ul .api-item-bg .api-item-txt .start-btn span {
  position: relative;
  transform: translateY(0);
  display: block;
  width: 100%;
  height: 100%;
  background: url(/static/image/start_btn.png) no-repeat;
  transition: all 0.3s ease;
}
.esports02-main .esports02-wrap .tab-main ul .api-item-bg .api-item-txt .start-btn span:before {
  content: '';
  display: block;
  width: 100%;
  height: 100%;
  background: url(/static/image/start_btn_hover.png) no-repeat;
  transition: opacity 0.3s ease;
  opacity: 0;
}
.esports02-main .esports02-wrap .tab-main ul .api-item-bg .api-item-txt .start-btn:hover span:before {
  opacity: 1;
}
.esports02-main .esports02-wrap .tab-main ul .api-item-bg .api-item-txt .start-btn:active span {
  transform: translateY(5px);
}
/*底部切换按钮 tab-nav*/
.esports02-main .esports02-wrap .tab-nav {
  position: absolute;
  bottom: 50px;
  left: 0;
  top: auto;
  right: 0;
  z-index: 20;
}
.esports02-main .esports02-wrap .tab-nav ul {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  list-style: none;
}
.esports02-main .esports02-wrap .tab-nav ul .api-item-nav {
  margin-top: 10px;
  padding: 0 7px;
}
.esports02-main .esports02-wrap .tab-nav ul .api-item-nav a {
  position: relative;
  display: block;
  width: 285px;
  height: 103px;
  background: no-repeat center / contain;
  font-size: 0;
  transition: all 0.3s ease;
}
.esports02-main .esports02-wrap .tab-nav ul .api-item-nav a span {
  display: block;
  width: 100%;
  height: 100%;
  background: no-repeat center / contain;
  font-size: 0;
  transition: all 0.3s ease;
  opacity: 0;
}
.esports02-main .esports02-wrap .tab-nav ul .api-item-nav.active a span,
.esports02-main .esports02-wrap .tab-nav ul .api-item-nav:hover a span {
  opacity: 1;
}
.esports02-main .esports02-wrap .tab-nav ul .api-item-nav:active a {
  transform: translateY(5px);
}
.esports02-main .esports02-wrap .tab-nav[data-count='5'],
.esports02-main .esports02-wrap .tab-nav[data-count='6'],
.esports02-main .esports02-wrap .tab-nav[data-count='7'],
.esports02-main .esports02-wrap .tab-nav[data-count='8'] {
  bottom: 20px;
}

@media screen and (max-width: 1200px) {
  .esports02-main .contain {
    width: 1000px;
  }
  .esports02-main .esports02-wrap .tab-nav[data-count='4'] ul .api-item-nav a,
  .esports02-main .esports02-wrap .tab-nav[data-count='5'] ul .api-item-nav a,
  .esports02-main .esports02-wrap .tab-nav[data-count='6'] ul .api-item-nav a,
  .esports02-main .esports02-wrap .tab-nav[data-count='7'] ul .api-item-nav a,
  .esports02-main .esports02-wrap .tab-nav[data-count='8'] ul .api-item-nav a {
    width: 236px;
    height: 86px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mode/gaming.vue